const rowdata = [
  /*{ heading: 'ADVISE ON IT SOLUTIONS FOR YOUR BUSSINESS.', icon: 'fa fa-lightbulb-o', items: [
    'The Firm has a rich experience in Internal, Statutory & Management \
     Audits of SME sector. Beside audits, direct & indirect taxation is \
     one of the firms core competencies.'
  ]},
  { heading: 'KEEP OUR CLIENTS UPDATED OF CHANGES IN THE LAW.', icon: 'fa fa-book', items: [
    'The Firm has a reputation of providing very good accounting service \
     on all the related matters like seed funding, indirect taxation, \
     direct taxation, compliance audits, etc.'
  ]},
  { heading: 'PERFORM TIMELY RELIABLE AND ACCURATE AUDITS', icon: 'fa fa-clock-o', items: [
    'Our Firm has a team of experts that has years of experience in accounting \
     audits and as a result we are able to provide timely, most reliable and \
     accurate accounting audits.'
  ]},
  { heading: 'ENSURERING CLIENTS SATISFACTION IS OUR GOAL', icon: 'fa fa-user', items: [
    'Our main aim is to keep our clients updated with all changing market \
     situations and to provide them satisfactory accounting solutions on \
     time.'
  ]},*/
];
export default rowdata;



// WEBPACK FOOTER //
// ./src/OurTeamPage/rowdata.js